require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[5],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(223);


/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _BaseInput = _interopRequireDefault(__webpack_require__(224));

exports.default = _BaseInput.default;
exports.BaseInput = _BaseInput.default;

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _BaseInput = _interopRequireDefault(__webpack_require__(225));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  BaPropTypes
} = _utils.propsUtils;
const {
  uniqueId
} = _utils.lodash;
const {
  sanitize
} = _utils.propsUtils;
const {
  isKey,
  keyNames
} = _utils.keyboardUtils;
const {
  resolveBaseTextDir
} = _utils.bidiUtils;
const MESSAGE_TYPE_ERROR = 'error';
const MESSAGE_TYPE_WARNING = 'warning';
const MESSAGE_TYPE_INFORMATIONAL = 'informational';
const MESSAGE_TYPE_SUCCESS = 'success';

const _CLASS = _BaseInput.default.baseInputClassName.replace(/"/g, ''); // eslint-disable-line no-underscore-dangle


class BaseInput extends _react.Component {
  constructor(_props) {
    super(_props);
    (0, _defineProperty2.default)(this, "_useOnValueCallbacks", !!this.props.onValueChange || !!this.props.onValueAccept);
    (0, _defineProperty2.default)(this, "focus", () => {
      const {
        disabled
      } = this.props;
      !disabled && this.inputNode && this.inputNode.focus();
    });
    (0, _defineProperty2.default)(this, "select", () => {
      const {
        disabled
      } = this.props;
      !disabled && this.inputNode && this.inputNode.select();
    });
    (0, _defineProperty2.default)(this, "_onChange", e => {
      const {
        onChange
      } = this.props;
      const newValue = e.type === 'click' ? this.inputNode.value : e.target.value;
      this.setState({
        newValue
      });

      if (this._useOnValueCallbacks) {
        this._onValueChange(newValue);

        onChange && onChange(e);

        if (e.type === 'click') {
          this._onValueAccept(newValue);
        }
      } else {
        // this really really needs to get done(switch to native onChange behaviour)
        onChange && onChange(newValue, false);
      }
    });
    (0, _defineProperty2.default)(this, "_onValueChange", newValue => {
      const {
        onValueChange
      } = this.props;
      onValueChange && onValueChange(newValue);
    });
    (0, _defineProperty2.default)(this, "_onKeyUp", e => {
      const {
        type,
        onKeyUp
      } = this.props;
      const {
        value: newValue
      } = e.target;
      this.setState({
        newValue
      });

      if (type !== 'password' && isKey(e, keyNames.ENTER) || type === 'number' && (isKey(e, keyNames.UP
      /* 38 */
      ) || isKey(e, keyNames.DOWN
      /* 40 */
      ))) {
        if (this._useOnValueCallbacks) {
          this._onValueAccept(newValue);
        }
      }

      onKeyUp && onKeyUp(e);
    });
    (0, _defineProperty2.default)(this, "_onBlur", e => {
      const {
        onBlur
      } = this.props;
      const {
        value: newValue
      } = e.target;

      if (this._useOnValueCallbacks) {
        this._onValueAccept(newValue);
      }

      onBlur && onBlur(e);
    });
    (0, _defineProperty2.default)(this, "_onValueAccept", newValue => {
      const {
        onValueAccept
      } = this.props;
      this.setState({
        newValue: null
      }); // toolkit widgets that call BaseInput need to check if
      // newValue !== oldValue before calling their onValueAccept
      // DO NOT do the check here, each widget applies prop limit checks

      onValueAccept && onValueAccept(newValue);
    });
    (0, _defineProperty2.default)(this, "_ref", node => this.inputNode = node);
    (0, _defineProperty2.default)(this, "_autoComplete", this.props.autoComplete || 'off');
    (0, _defineProperty2.default)(this, "_id", uniqueId('ba-common-base-input'));
    (0, _defineProperty2.default)(this, "_inputToRender", props => this.props.inputToRender(props));
    (0, _defineProperty2.default)(this, "_messageType", () => {
      if (this.props.hasValidationError && this.props.validationErrorText) {
        return MESSAGE_TYPE_ERROR;
      }

      if (this.props.isMoreInfo && this.props.moreInfoText) {
        return MESSAGE_TYPE_INFORMATIONAL;
      }

      if (this.props.successText) {
        return MESSAGE_TYPE_SUCCESS;
      }

      return undefined;
    });
    (0, _defineProperty2.default)(this, "_messageNode", () => {
      const messageType = this._messageType();

      if (messageType === MESSAGE_TYPE_ERROR) {
        return this.props.validationErrorText;
      }

      if (messageType === MESSAGE_TYPE_INFORMATIONAL) {
        return this.props.moreInfoText;
      }

      if (messageType === MESSAGE_TYPE_SUCCESS) {
        return this.props.successText;
      }

      return undefined;
    });
    this.state = {
      newValue: null
    };
  }

  componentDidMount() {
    const {
      autoFocus,
      autoSelect,
      onChange
    } = this.props;
    autoFocus && this.focus();
    autoSelect && this.select(); // eslint-disable-next-line react/prop-types

    if (onChange) {
      console.warn('Warning - consider using onValueChange/onValueAccept: the behaviour of onChange will change to the native event when onValueChange/onValueAccept becomes the default behaviour');
    }
  }

  componentWillReceiveProps({
    value: newValue
  }) {
    const {
      value: oldValue
    } = this.props;

    if (newValue !== oldValue) {
      this.setState({
        newValue: null
      });
    }
  }

  componentWillUnmount() {
    const {
      newValue
    } = this.state;

    if (newValue !== null) {
      if (this._useOnValueCallbacks) {
        this._onValueAccept(newValue);
      } else {
        // this really really needs to get done(switch to native onChange behaviour)
        this.props.onChange(newValue, true);
      }
    }
  } // eventually/hopefully onValueChange/onValueAccept will be the norm, and useOnValueCallbacks can be removed


  render() {
    // extract props that are to be manipulated or not passed down
    const {
      // baseInput specific
      // inherited props
      value,
      className,
      children,
      fullWidth,
      title,
      textAlign,
      dir,
      textDir,
      type,
      hasValidationError,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      validationErrorText,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      successText,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      isMoreInfo,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      moreInfoText,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      onChange,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      moreInfoClickHandler,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      onValueChange,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      onValueAccept,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      disabled,
      light,
      readOnly,
      inputToRender,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      style,
      // all the other props
      ...others
    } = this.props;

    const messageType = this._messageType();

    const classNames = (0, _utils.classnames)(_CLASS, {
      fullWidth,
      error: messageType === MESSAGE_TYPE_ERROR,
      warning: messageType === MESSAGE_TYPE_WARNING,
      informational: messageType === MESSAGE_TYPE_INFORMATIONAL,
      success: messageType === MESSAGE_TYPE_SUCCESS
    });
    const widgetProps = {
      'data-tid': `${this._ID}__input`,
      ...sanitize(others, null),
      value: type === 'password' ? undefined : value || '',
      onChange: this._onChange,
      onKeyUp: this._onKeyUp,
      onBlur: this._onBlur,
      autoComplete: this._autoComplete,
      type,
      ref: this._ref,
      dir: resolveBaseTextDir(value, textDir, false),
      disabled: disabled || readOnly,
      light,
      style: { ...style,
        ...(textAlign ? {
          textAlign
        } : {})
      },
      invalid: !!messageType,
      invalidText: this._messageNode()
    };
    return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, dir ? {
      dir
    } : {}, {
      title: title,
      className: `${classNames} ${className}`
    }), this._inputToRender(widgetProps), children);
  }

}

exports.default = BaseInput;
(0, _defineProperty2.default)(BaseInput, "propTypes", {
  id: _propTypes.default.string,
  'data-tid': _propTypes.default.string,
  className: _propTypes.default.string,
  title: _propTypes.default.string,
  type: _propTypes.default.oneOf(['password', 'time', 'number']),
  textAlign: _propTypes.default.oneOf(['left', 'right', 'center']),
  textDir: _propTypes.default.oneOf(['', 'ltr', 'rtl', 'auto']),
  dir: _propTypes.default.oneOf(['ltr', 'rtl']),
  fullWidth: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  // Carbon light variant of the component
  light: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  children: _propTypes.default.node,
  onKeyUp: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  autoFocus: _propTypes.default.bool,
  autoSelect: _propTypes.default.bool,
  allowEmpty: _propTypes.default.bool,

  /** callback function, to render the specific type of input */
  inputToRender: _propTypes.default.func,

  /** callback function, to deal with input as it changes */
  onValueChange: _propTypes.default.func,

  /** callback function, to deal with input when it is final */
  onValueAccept: _propTypes.default.func,
  // deprecated - not supported or no equivalent in Carbon

  /** deprecated: not applicable to carbon */
  active: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  ariaLabelledBy: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  hover: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  icon: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  iconLeft: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  iconRight: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  noBottomBorder: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  style: BaPropTypes.deprecated('deprecated: not applicable to carbon'),
  // deprecated - supported in a different way

  /** deprecated: use onValueChange/onValueAccept to replace fireOnBlur/onChange/onBlur */
  fireOnBlur: BaPropTypes.deprecated('deprecated: use onValueChange/onValueAccept to replace fireOnBlur/onChange/onBlur'),

  /** deprecated: to be replaced/remapped when Carbon message handling is updated */
  hasValidationError: BaPropTypes.deprecated('deprecated: to be replaced/remapped when Carbon message handling is updated'),

  /** deprecated: to be replaced/remapped when Carbon message handling is updated */
  isMoreInfo: BaPropTypes.deprecated('deprecated: to be replaced/remapped when Carbon message handling is updated'),

  /** deprecated: to be replaced/remapped when Carbon message handling is updated */
  moreInfoClickHandler: BaPropTypes.deprecated('deprecated: to be replaced/remapped when Carbon message handling is updated'),

  /** deprecated: to be replaced/remapped when Carbon message handling is updated */
  moreInfoText: BaPropTypes.deprecated('deprecated: to be replaced/remapped when Carbon message handling is updated'),

  /** deprecated: to be replaced/remapped when Carbon message handling is updated */
  successText: BaPropTypes.deprecated('deprecated: to be replaced/remapped when Carbon message handling is updated'),

  /** deprecated: to be replaced/remapped when Carbon message handling is updated */
  validationErrorText: BaPropTypes.deprecated('deprecated: to be replaced/remapped when Carbon message handling is updated'),

  /** deprecated: use disabled */
  readOnly: BaPropTypes.deprecated('deprecated: use disabled')
});
(0, _defineProperty2.default)(BaseInput, "defaultProps", {
  className: ''
});

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_BaseInput_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_BaseInput_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_BaseInput_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_BaseInput_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_BaseInput_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-baseInput{position:relative;display:inline-block}.ba-common-baseInput.is-fullWidth{display:block;width:100%}.ba-common-baseInput.is-fullWidth .bx--number--helpertext{width:100%}.ba-common-baseInput.is-error .bx--text-input__field-wrapper[data-invalid]{outline-color:red}.ba-common-baseInput.is-error .bx--text-input__invalid-icon{fill:red}.ba-common-baseInput.is-error .bx--form-requirement{color:red}.ba-common-baseInput.is-warning .bx--text-input__field-wrapper[data-invalid]{outline-color:peru}.ba-common-baseInput.is-warning .bx--text-input__invalid-icon{fill:peru}.ba-common-baseInput.is-warning .bx--form-requirement{color:peru}.ba-common-baseInput.is-informational .bx--text-input__field-wrapper[data-invalid]{outline-color:#add8e6}.ba-common-baseInput.is-informational .bx--text-input__invalid-icon{fill:#add8e6}.ba-common-baseInput.is-informational .bx--form-requirement{color:#add8e6}.ba-common-baseInput.is-success .bx--text-input__field-wrapper[data-invalid]{outline-color:green}.ba-common-baseInput.is-success .bx--text-input__invalid-icon{fill:green}.ba-common-baseInput.is-success .bx--form-requirement{color:green}", ""]);

// exports
exports.locals = {
	"baseInputClassName": "\"ba-common-baseInput\""
};

/***/ })

},[[222,0]]]);
});